import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import nameimg from "../../../../assets/name-text.svg";

import Title from "../Title";
import { Link } from "react-router-dom";

export const InvitationEmail = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <div className={"formcontainer" + " " + style.container}>
      <Link to="/"><Title /></Link>
      <div className={style.wrapper}>

        <Card view="raised" className={"formstyle" + " " + style.card} >
          <Typography
            type={device === "mobile" ? "h6" : "h5"}
            colorStep={100}
            tagName="div"
            className={"formheadsmall"}
            style={{ textAlign: "center" }}
          >
            Your team is waiting for you to join them
          </Typography>
          <div className="teammember  d-inline-flex align-items-center" >
            <img className="img-profile rounded-circle" src={nameimg} />
            <div className="profile-details d-lg-inline">
              <div className="d-block small-name" >Rahul Sharma </div>
              <div className="d-block small-con" >has invited you to collaborate on <br /><a href="/">Loremipsum.digtialapple.qc.net</a></div>
            </div>
          </div>

          <Link to="/TeamAccountSetUp"><Button className={"formsbutton"}
            type="default"
            view="filled"
            color="primary"
            text="Join this team"
            fill={true}

            onClick={() => setOpen(true)}
          /></Link>

        </Card>
      </div >

    </div >
  );
};

export default InvitationEmail;
